import React from 'react';
import Input from './input/input';
import Select from './select/select';
import Date from './date/date';
import Message from './message/message';
import Employees from './employees/employees';
import Companies from './companies/companies';
import Vehicles from './vehicles/vehicles';
import LicensePlate from './license-plate/license-plate';

const Field = ({ typename, ...props }) => {
  switch (typename) {
    case 'STRAPI__COMPONENT_FORMS_INPUT':
      return <Input key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_SELECT':
      return <Select key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_DATE':
      return <Date key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_MESSAGE':
      return <Message key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_EMPLOYEES':
      return <Employees key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_COMPANIES':
      return <Companies key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_VEHICLES':
      return <Vehicles key={props.id} {...props} />;
    case 'STRAPI__COMPONENT_FORMS_LICENSE_PLATE':
      return <LicensePlate key={props.id} {...props} />;
    default:
      console.warn(`Didn't understand the form field typename ${typename}`);
      return null;
  }
};

export default Field;
